export const PRINT_INVOICE = '/api/v2/invoice/for-parent/print';
